import * as GLOBALS from "../globals";
import Rellax from "rellax";

export default class Hero {
	static init(startingAnimation) {
		if (window.innerWidth < GLOBALS.BREAKPOINT_LG) return;

		return new Hero(startingAnimation);
	}

	constructor(startingAnimation) {
		const rellaxItems = document.querySelectorAll('.hero [data-rellax]');
		// inverse starting animation
		if (startingAnimation && rellaxItems.length !== 0) {
			rellaxItems.forEach(element => {
				if(element.dataset.rellaxSpeed > 0) element.style.transform = "translate(0px, -100px)";
				else if(element.dataset.rellaxSpeed < 0) element.style.transform = "translate(0px, 100px)";

				element.style.display = "flex";
				element.style.transition = "all 1400ms ease-in-out";
				
				setTimeout(() => {
					element.style.transform = "translate(0px, 0px)";
				}, 100);
					
					
				setTimeout(() => {
					element.style.transition = "none";
				}, 2000)
			});

			

			setTimeout(() => {
				let rellax = new Rellax('[data-rellax]');
		
				window.addEventListener('resize', this.debounce(function () {
					if (typeof rellax.destroy === 'function') {
						rellax.destroy();
						Hero.init(false);
					}
				}));

			}, 1500);
		}
		else {
			let rellax = new Rellax('[data-rellax]');
	
			window.addEventListener('resize', this.debounce(function () {
				if (typeof rellax.destroy === 'function') {
					rellax.destroy();
					Hero.init(false);
				}
			}));
		}
				
	}

	debounce(func) {
		let timer;
		return function (event) {
			if (timer) clearTimeout(timer);
			timer = setTimeout(func, 100, event);
		};
	}
}
